goog.provide("shadow.js.shim.module$$mui$x_tree_view$SimpleTreeView");
goog.provide("module$shadow_js_shim_module$$mui$x_tree_view$SimpleTreeView");
shadow.js.shim.module$$mui$x_tree_view$SimpleTreeView = shadow.js.nativeProvides["@mui/x-tree-view/SimpleTreeView"] = shadow$bridge("@mui/x-tree-view/SimpleTreeView");
module$shadow_js_shim_module$$mui$x_tree_view$SimpleTreeView.default = shadow.js.shim.module$$mui$x_tree_view$SimpleTreeView;
